import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { connect } from "react-redux";
import "./DropdownModal.scss";
import { withRouter, useHistory } from "react-router-dom";
//components
import PageTitle from "../../components/common/pageTitle";
import { Content } from "../../components/ifern4p";
import Spinner from "../../shared/Spinner";
import { useSelector } from "react-redux";
//style
import style from "../../components/ifern4p/ilifepoint.module.scss";
//service
import Ifern4pService from "../../../service/ifern4p/ifern4p";
import UserStore from "../../../store/UserStore";
//data
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import DropdownButton from "../../components/ifern4p/DropdownButton";
import IlifeModal from "../../components/ifern4p/IlifeModal";

const mapStateToProps = (state) => ({ lang: state.Lang });

const Ifern4p = (props) => {
  const Currency = useSelector((state) => state.curr);
  const { t } = props;
  const [buttonItems, setButtonItems] = useState([]);
  const items = [
    { id: 4, label: "4P Code Generator" },
    { id: 1, label: "4P Registration" },
    { id: 2, label: "4P GSR Code Activation" },
  ];

  const [selectedTab, setselectedTab] = useState("fourpcodelisthistory");
  const [selectedItems, setSelectedItems] = useState([]);
  const [loader, setLoader] = useState({
    EarningsTable: {
      search: false,
      reset: false,
      excel: false,
      csv: false,
      print: false,
    },
    HistoryTable: {
      search: false,
      reset: false,
    },
  });

  const handleItemClick = (item) => {
    console.log(`Clicked item: ${item.label}`);
    const itemIndex = selectedItems.findIndex(
      (selectedItem) => selectedItem.id === item.id
    );
    if (itemIndex === -1) {
      const newSelectedItems = [
        ...selectedItems,
        { ...item, displayModal: true },
      ];
      setSelectedItems(newSelectedItems);
    } else {
      const newSelectedItems = [...selectedItems];
      newSelectedItems[itemIndex].displayModal = true;
      setSelectedItems(newSelectedItems);
    }
  };

  const handleCloseModal = (itemId) => {
    const itemIndex = selectedItems.findIndex(
      (selectedItem) => selectedItem.id === itemId
    );
    const newSelectedItems = [...selectedItems];
    newSelectedItems[itemIndex].displayModal = false;
    setSelectedItems(newSelectedItems);
  };

  const [locationKeys, setLocationKeys] = useState([]);
  const history = useHistory();

  const [state, setState] = useState({
    Modal: {
      fundTransfer: false,
      addWallet: false,
    },
    tilesData: [],
    balanceAmount: "",
    TransactionFee: "",
    repurchase_status: "yes",
    loading: true,
    DataTables: {
      key: UserStore.checkUserEarnings ? "earning" : "statement",
      history: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
        startDate: moment().subtract(29, "days"),
        endDate: moment(),
        direction: "",
      },
      earnings: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
        startDate: moment().subtract(29, "days"),
        endDate: moment(),
        direction: "",
        category: [],
      },
    },
    generateFourpCode: false,
    fourpCodeListAndHistory: false,
    fourpRegistration: false,
    fourpReorderActivation: false,
    fourpActivatedProductList: false,
  });

  const service = new Ifern4pService();

  useEffect(() => {
    history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
        if (location.pathname === "/dashboard") {
          UserStore.checkUserEarnings = false;
        }
      }
      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);
          UserStore.checkUserEarnings = false;
        }
      }
    });
    //componentdidmount
    loadData();
  }, [props, locationKeys, Currency.currentCurr]);

  //load the data
  const loadData = () => {
    // ifern 4p tiles
    service.Ifern4p().then((res) => {
      if (res.status) {
        console.log(res.data, "inside ifern 4p");
        setState((prevState) => ({
          ...prevState,
          tilesData: res.data.tile,
          balanceAmount: 0,
          TransactionFee: 0,
          repurchase_status: false,
          purchase_wallet: false,
          loading: false,
          generateFourpCode: res.data.generateFourpCode,
          fourpCodeListAndHistory: res.data.fourpCodeListAndHistory,
          fourpRegistration: res.data.fourpRegistration,
          fourpReorderActivation: res.data.fourpReorderActivation,
          fourpActivatedProductList: res.data.fourpActivatedProductList,
        }));
      }
      // else {
      //   // props.history.push("/logout");
      // }
    });
    getHistoryTable();
    getUserEarningsTable();
  };

  useEffect(() => {
    const newItems = [];
    if (state.generateFourpCode) {
      newItems.push({ id: 4, label: "4P Code Generator" });
    }
    if (state.fourpRegistration) {
      newItems.push({ id: 1, label: "4P Registration" });
    }
    if (state.fourpReorderActivation) {
      newItems.push({ id: 2, label: "4P GSR Code Activation" });
    }
    setButtonItems(newItems);
  }, [
    state.generateFourpCode,
    state.fourpRegistration,
    state.fourpReorderActivation,
  ]);

  //get fourp activated history table data
  const getHistoryTable = (
    inPage = state.DataTables.history.inPage,
    perPage = state.DataTables.history.perPage,
    direction = "",
    startDate = moment().startOf("month").format("MMMM D, YYYY"),
    endDate = moment().format("MMMM D, YYYY"),
    order = "",
    keys = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service
      .activatedList(start, perPage, direction, startDate, endDate, order, keys)
      .then((res) => {
        console.log(" ==== inside fourp activated history ==== ");
        if (res.status) {
          console.log(" ==== inside fourp activated history ==== ", res);
          setLoader({
            EarningsTable: {
              search: false,
              reset: false,
              excel: false,
              csv: false,
              print: false,
            },
            HistoryTable: {
              search: false,
              reset: false,
            },
          });
          setState((prevState) => ({
            ...prevState,
            DataTables: {
              ...prevState.DataTables,
              history: {
                ...prevState.DataTables.history,
                totalRows: res.data.count,
                data: res.data.result,
                pending: false,
              },
            },
          }));
        } else {
          // props.history.push("/logout");
        }
      });
  };

  //change table data
  const changeHistoryTable = (
    inPage,
    perPage,
    start,
    end,
    dierection,
    colKey,
    key
  ) => {
    console.log(" ==== inside change history table ==== ");
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        history: {
          ...prevState.DataTables.history,
          perPage: perPage,
          inPage: inPage,
          // pending     : true,
          startDate: start,
          endDate: end,
          direction: dierection,
        },
      },
    }));
    getHistoryTable(inPage, perPage, dierection, start, end, colKey, key);
  };

  //get the downline activation history
  const getUserEarningsTable = (
    inPage = state.DataTables.earnings.inPage,
    perPage = state.DataTables.earnings.perPage,
    direction = "",
    startDate = moment().startOf("month").format("MMMM D, YYYY"),
    endDate = moment().format("MMMM D, YYYY"),
    order = "",
    keys = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service
      .history(start, perPage, direction, startDate, endDate, order, keys)
      .then((res) => {
        if (res.status) {
          setLoader({
            EarningsTable: {
              search: false,
              reset: false,
              excel: false,
              csv: false,
              print: false,
            },
            HistoryTable: {
              search: false,
              reset: false,
            },
          });

          setState((prevState) => ({
            ...prevState,
            DataTables: {
              ...prevState.DataTables,
              earnings: {
                ...prevState.DataTables.earnings,
                totalRows: res.data.total,
                data: res.data.result,
                pending: false,
                category: [],
              },
            },
          }));
        } else {
          // props.history.push("/logout");
        }
      });
  };

  //change table data
  const changeEarningsTable = (
    inPage,
    perPage,
    start,
    end,
    dierection,
    colKey,
    key
  ) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        earnings: {
          ...prevState.DataTables.earnings,
          perPage: perPage,
          inPage: inPage,
          // pending     : true,
          startDate: start,
          endDate: end,
          direction: dierection,
        },
      },
    }));
    getUserEarningsTable(inPage, perPage, dierection, start, end, colKey, key);
  };

  const Translation = (data, tab) => {
    let newData;
    if (tab === "fourpcodelisthistory") {
      newData = data.map((item) => {
        console.log("itemsss", item);
        if (item) {
          return {
            ...item,
          };
        } else return item;
      });
    } else {
      newData = data.map((item) => {
        if (item) {
          return {
            ...item,

            price: `${Currency.currentCurr}${(
              parseFloat(item.price) * Currency.value
            ).toFixed(Currency.precision)}`,
          };
        } else return item;
      });
    }
    return newData;
  };

  const ExportToExcel = (apiData, fileName, type, tab) => {
    console.log("ExportToExcel", tab);
    let fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let fileExtension = ".xlsx";
    if (tab === "fourpcodelisthistory") {
      if (type === "excel") {
        console.log("apidata", Translation(apiData, tab));
        // const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Expiration Date",
            "Activation Code",
            "Security Code",
            // "Product Name",
            "Status",
            "BUV",
          ],
        ]);

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
        // };
      } else if (type === "csv") {
        fileExtension = ".csv";
        let fileType = "text/csv;charset=utf-8";
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Expiration Date",
            "Activation Code",
            "Security Code",
            "Status",
            "BUV",
          ],
        ]);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        const data = new Blob([csvOutput], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      } else if (type === "print") {
        //  let printView = <UserEarningsPrintView
        //      data={apiData}
        // />
      }
    } else {
      if (type === "excel") {
        console.log("apidata", Translation(apiData, tab));
        // const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "4P Username",
            "Activation Date",
            "Activation  Code",
            "Security Code",
            "Product Name",
            "PV",
            "Product Cost",
          ],
        ]);

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
        // };
      } else if (type === "csv") {
        fileExtension = ".csv";
        let fileType = "text/csv;charset=utf-8";
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Username",
            "Date",
            "Access Code",
            "Security Code",
            "Product Name",
            "PV",
            "Product Cost",
          ],
        ]);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        const data = new Blob([csvOutput], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      } else if (type === "print") {
        //  let printView = <UserEarningsPrintView
        //      data={apiData}
        // />
      }
    }
  };

  // Export Data
  const exportData = (
    startdate = "",
    enddate = "",
    categories = "",
    type,
    tab
  ) => {
    console.log("exporttt", tab);
    let keys = categories
      .map((key, idx) => {
        return "categories[" + idx + "]=" + key.value;
      })
      .join("&");
    if (tab === "fourpcodelisthistory") {
      if (type === "excel") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: true,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
      if (type === "print") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: true,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
      if (type === "csv") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: true,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
    } else {
      if (type === "excel") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: true,
            csv: false,
          },
        });
      }
      if (type === "print") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
          },
        });
      }
      if (type === "csv") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: true,
          },
        });
      }
    }

    if (tab === "fourpcodelisthistory") {
      service.exportDataHistory(startdate, enddate, keys, type).then((res) => {
        if (type === "excel") {
          ExportToExcel(
            res.data.result,
            "Fourp Code List And History",
            type,
            tab
          );
        }
        if (type === "csv") {
          ExportToExcel(
            res.data.result,
            "Fourp Code List And History",
            type,
            tab
          );
        }

        if (type === "print") {
          ExportToExcel(res.data.result, "Fourp Code List And History", type);
        }

        // if(type==='excel'){
        //     fileDownload(res, 'User Earnigs Report.xlsx');
        // }
      });
    } else {
      service.exportData(startdate, enddate, keys, type).then((res) => {
        if (type === "excel") {
          ExportToExcel(res.data.result, "Fourp Activated Product List", type);
        }
        if (type === "csv") {
          ExportToExcel(res.data.result, "Fourp Activated Product List", type);
        }

        if (type === "print") {
          ExportToExcel(res.data.result, "Fourp Activated Product List", type);
        }

        // if(type==='excel'){
        //     fileDownload(res, 'User Earnigs Report.xlsx');
        // }
      });
    }
  };

  //tab change function(ddn't added this)
  const tabChangeHandler = (tab) => {
    setselectedTab(tab);
    console.log("tabbbbb", tab);
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        statement: {
          ...prevState.DataTables.statement,
          perPage: 10,
          inPage: 1,
        },
        history: {
          ...prevState.DataTables.history,
          perPage: 10,
          inPage: 1,
        },
        wallet: {
          ...prevState.DataTables.wallet,
          perPage: 10,
          inPage: 1,
        },
        earnings: {
          ...prevState.DataTables.earnings,
          perPage: 10,
          inPage: 1,
        },
      },
    }));

    // getstatementTable();
    getHistoryTable();
    // getWalletTable();
    getUserEarningsTable();
  };

  const paginationHandler = {
    history: changeHistoryTable,
    earnings: changeEarningsTable,
  };

  return (
    <div className={`h-100`}>
      <Helmet>
        <title>
          {/* {companyName.companyName} | {t("Sidemenu.ilifestylepoint")} */}
        </title>
      </Helmet>
      <PageTitle
        title="iFern4p"
        //  buttonOn={true} group={ButtonGroup}
      />
      {state.loading ? (
        <Spinner />
      ) : (
        <div className={style.MainContainer}>
          {/* <div>
            {state.tilesData && (
              <Tiles
                tilesData={state.tilesData}
                repurchase_status={state.purchase_wallet}
              />
            )}
          </div> */}

          <Content
            tableData={state.DataTables}
            changeHandler={tabChangeHandler}
            paginationHandler={paginationHandler}
            repurchase_status={state.purchase_wallet}
            exportData={exportData}
            selectedTab={selectedTab}
            loader={loader}
            state={state}
          />
          <div className="container">
            <DropdownButton
              buttonText={<>4P CODE GENERATOR</>}
              items={buttonItems}
              onItemClick={handleItemClick}
              style={{ width: "-moz-available" }}
              isFourp={true}
            />

            {selectedItems.map((selectedItem) =>
              selectedItem.displayModal ? (
                <IlifeModal
                  key={selectedItem.id}
                  item={selectedItem}
                  onClose={() => handleCloseModal(selectedItem.id)}
                />
              ) : null
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(connect(mapStateToProps)(withRouter(Ifern4p)));
